/*
 * The bPanel logo, inlined from /Branding/logo-icons (paths unchanged, as on the landing). The mark is always
 * brand blue with white LEDs; the wordmark is navy. Never recolour. Decorative: the surrounding link carries
 * the accessible name. Use the lockup where there are 140 px or more, the mark below that.
 */
import { cn } from '@/lib/cn'

function MarkPaths() {
  return (
    <>
      <g className="fill-brand-vivid">
        <rect x="468" y="228" width="58" height="160" />
        <path
          fillRule="evenodd"
          d="M595 261a127 127 0 1 1 0 254a127 127 0 1 1 0-254zM595 319a69 69 0 1 0 0 138a69 69 0 1 0 0-138z"
        />
        <rect x="551" y="358" width="89" height="16" rx="8" />
        <rect x="551" y="389" width="89" height="16" rx="8" />
        <rect x="551" y="419" width="89" height="16" rx="8" />
      </g>
      <g className="fill-white">
        <circle cx="629" cy="366" r="4.5" />
        <circle cx="629" cy="397" r="4.5" />
        <circle cx="629" cy="427" r="4.5" />
      </g>
    </>
  )
}

export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="466 226 258 293" className={cn('block', className)} aria-hidden="true" focusable="false">
      <MarkPaths />
    </svg>
  )
}

export function LogoLockup({ className, inverted }: { className?: string; inverted?: boolean }) {
  return (
    <svg
      viewBox="466 226 1243 293"
      className={cn('block', className)}
      aria-hidden="true"
      focusable="false"
      direction="ltr"
    >
      <MarkPaths />
      <g fill="none" className={inverted ? 'stroke-white' : 'stroke-ink-deep'} strokeWidth="57">
        <path d="M771.5 513V256.5H879.5A70 70 0 0 1 879.5 396.5H771.5" />
        <circle cx="1083" cy="408" r="80" />
        <path d="M1163 300V513" />
        <path d="M1240 513V300M1240 400.5A72.5 72.5 0 0 1 1385 400.5V513" />
        <path d="M1452 408H1612A80 80 0 1 0 1588.6 464.6" />
        <path d="M1678.5 228V513" />
      </g>
    </svg>
  )
}

/** The logo's three rack lines, as a small ornament (kickers, dividers). */
export function RackGlyph({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 16 12"
      className={cn('h-3 w-4 shrink-0', className)}
      aria-hidden="true"
      focusable="false"
    >
      <rect x="0" y="0" width="16" height="3" rx="1.5" fill="currentColor" />
      <rect x="0" y="4.5" width="16" height="3" rx="1.5" fill="currentColor" opacity="0.7" />
      <rect x="0" y="9" width="16" height="3" rx="1.5" fill="currentColor" opacity="0.45" />
    </svg>
  )
}
